import { useTranslation } from "react-i18next";
import styles from "./LanguageSwitcher.module.css";

const languages = [
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" },
  { code: "kk", label: "KK" },
  { code: "uz", label: "UZ" },
  { code: "fi", label: "FI" },
  { code: "sv", label: "SV" },
];

interface LanguageSwitcherProps {
  variant?: "default" | "hero";
}

function LanguageSwitcher({ variant = "default" }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const className = variant === "hero" ? `${styles.select} ${styles.hero}` : styles.select;

  return (
    <select
      className={className}
      value={i18n.language?.slice(0, 2)}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
    >
      {languages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.label}
        </option>
      ))}
    </select>
  );
}

export default LanguageSwitcher;
